// extracted by mini-css-extract-plugin
export default {"modalStyle":"prodDetailsModal_modalStyle__kC-mj","headerStyle":"prodDetailsModal_headerStyle__4oeaa"};